import {TABLE_AREA_Z_INDEX} from '@constant/system';
import {ACTION_BUTTON_Z_INDEX} from '../ActionButtons';

export const CHIP_POSITION = {
  MOBILE: {
    REGULAR_TABLE_AREA: 0.53,
    ALL_IN_TABLE_AREA: 0.565,
  },
  DESKTOP: {
    REGULAR_TABLE_AREA: 0.57,
    ALL_IN_TABLE_AREA: 0.67,
  },
};

const ANIMATION_SIZE = 150;

const desktop = theme => {
  const {toVW} = theme;
  return {
    gameResultContainer: {
      top: 'unset',
      left: 'unset',
      transform: 'translate(-116px, -113px)',
    },
    gameResultContainerAllIn: {
      top: 'unset',
      left: 'unset',
      transform: 'translate(-116px, -103px)',
    },
    chipSectionContainer: {
      top: '56%',
    },
    chipSectionContainerAllIn: {
      top: '61%',
      transform: 'unset',
    },
    potChipValue: {
      height: 16,
    },
    chipsWrapper: {
      minHeight: 28,
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    '@keyframes fadeIn': {
      '0%': {
        opacity: 0,
      },
      '100%': {
        opacity: 1,
      },
    },
    chipsWrapper: {
      minWidth: 35,
      minHeight: 32,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    // for positioning tableArea to center
    centerContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // color: 'white',
      // border: 'none',
      height: 'fit-content',
      // transformOrigin: '50% 0%',
      // TODO maybe affect emoji moving path
      transformOrigin: 'center',
    },
    chipSectionContainer: {
      position: 'absolute',
      zIndex: TABLE_AREA_Z_INDEX.CHIP,
      top: `${CHIP_POSITION.MOBILE.REGULAR_TABLE_AREA * 100}%`,
      height: 40,
      width: 40,
    },
    chipSectionContainerAllIn: {
      extend: 'chipSectionContainer',
      // transform: 'translate(-58px, -30px)',
      // top: 'unset',
      top: '63.5%', // in between cards and result container
    },
    potChip: {
      position: 'absolute',
    },
    potChipValue: {
      textAlign: 'center',
      width: 'max-content',
      background: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 3px 3px 5px rgba(0, 0, 0, 0.455)',
      borderRadius: 5,
      padding: '2px 5px',
      height: 20,
      marginTop: '-3px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    hiddenPreloadedVideosContainer: {
      position: 'fixed',
      visibility: 'hidden',
      top: 0,
      left: 0,
    },
    tableMessage: {
      background: '#000000',
      boxShadow: 'inset 0px 0px 20px 5px rgba(203, 178, 255, 0.5)',
      position: 'absolute',
      top: '40%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100vw',
      padding: [10, 5],
      textAlign: 'center',
      zIndex: TABLE_AREA_Z_INDEX.TABLE_MESSAGE,
      fontSize: '13px',
    },
    tableMessageAllIn: {
      extend: 'tableMessage',
      top: '55%',
    },
    gameResultContainer: {
      position: 'absolute',
      textAlign: 'center',
      // top: '61%',
      top: '48%',
      zIndex: TABLE_AREA_Z_INDEX.RESULT,
      fontSize: '20px',
      width: ANIMATION_SIZE,
    },
    gameResultContainerRelativeDiv: {
      position: 'relative',
      width: ANIMATION_SIZE,
      minHeight: ANIMATION_SIZE,
    },
    gameResultContainerAllIn: {
      extend: 'gameResultContainer',
      top: '60%',
    },
    combinationAnimationContainer: {
      position: 'absolute',
      margin: 'auto',
      minHeight: ANIMATION_SIZE,
      width: ANIMATION_SIZE,
    },
    combinationAnimationIndvContainer: {
      position: 'absolute',
      minHeight: ANIMATION_SIZE,
      width: ANIMATION_SIZE,
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
    },
    combinationNameGradient: {
      position: 'relative',
      top: -20,
      margin: 'auto',
      opacity: 0.81,
      background:
        'transparent radial-gradient(closest-side at 50% 50%, #6E6DFE 0%, #4A005DE6 34%, #400051BD 49%, #1F002933 100%)',
      fontSize: 12,
    },
    debugResultContainer: {
      position: 'absolute',
      top: 10,
      right: 0,
    },
    gameResultRow: {
      textAlign: 'center',
    },
    playerCard: {
      color: 'white',
    },
    playerIcon: {
      fontSize: 60,
    },
    playerMoney: {
      background: '#2A27B9 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #0000008C',
      borderRadius: '9px',
      opacity: '0.79',
      textAlign: 'center',
      color: 'white',
    },
    playerName: {
      textAlign: 'center',
      letterSpacing: '0px',
      textShadow: '0px 3px 6px #0000008C',
      color: 'white',
    },
    inAction: {
      border: '2px solid red',
    },
    hidden: {
      visibility: 'hidden',
    },
    displayNone: {
      display: 'none',
    },
    gameResultIMG: {
      marginTop: '10px',
      height: '120px',
      width: '150px',
      objectFit: 'contain',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
